
import * as z from "zod";

// Form validation schema for sign in
export const signInSchema = z.object({
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
  password: z.string().min(1, {
    message: "Password is required.",
  }),
  rememberMe: z.boolean().optional(),
});

export type SignInValues = z.infer<typeof signInSchema>;

// Form validation schema for password reset
export const resetSchema = z.object({
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
});

export type ResetValues = z.infer<typeof resetSchema>;

// Form validation schema for new password setup
export const newPasswordSchema = z.object({
  password: z.string().min(8, {
    message: "Password must be at least 8 characters long.",
  }),
  confirmPassword: z.string(),
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords do not match.",
  path: ["confirmPassword"],
});

export type NewPasswordValues = z.infer<typeof newPasswordSchema>;
